export default __webpack_public_path__ + "static/linea3-preview-1-mb-265cca24ca01310454f815647cb854a3.png";